import type { App } from 'vue';
import VueGoogleMaps from '@fawmi/vue-google-maps';

export default function (app: App) {
  app.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyBPW9Kfik0b542RvFMJA8NIHUQ1l3Iirtk',
      libraries: 'places',
      loading: 'async',
    },
  });
}
